module.exports = __webpack_public_path__ + "dropDownArrow.6a059c475b6ad11da0d9c66ab9429a71.svg";